const quantity_selector = document.querySelector(".luis-collection-slider-right");

if (quantity_selector) {
  quantity_selector.addEventListener("click", (e) => {
    
    const parent = e.target.closest(".smile-quantity-selector-wrap");
    let hidden_input = parent.querySelector('input[name="quantity"]');
    let quantity_input = parent.querySelector(".smile-quantity-input");
    const button = e.target.closest('button')
    
    
    if (button.name == "minus") {
      quantity_input.value = quantity_input.value <= 1 ? 1 : +quantity_input.value - 1;
      hidden_input.value = hidden_input.value <= 1 ? 1 : +hidden_input.value - 1;

    }

    if (button.name == "plus") {
      quantity_input.value = +quantity_input.value + 1;
      hidden_input.value = +hidden_input.value + 1;
    }
    
  });
}
